<template>
  <div class="flex-center-x gameContainer">
    <iframe
      id="gameIframe"
      :src="gameUrl"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
    <div
      v-if="isLoading && gameStartupDiagram"
      class="absolute top-0 z-50 left-0 w-full h-full bg-[#000] flex items-center justify-center"
    >
      <Image
        v-if="gameStartupDiagram"
        :src="gameStartupDiagram"
        class="w-full h-[100vh]"
      />
      <Image v-else :src="gameBg" class="w-[200px] h-[240px]" />
    </div>
    <DraggableIcon @click="handleNavigation">
      <div
        class="bg-[#000] size-10 rounded-full text-white flex-center-col text-xs bd-[1px_#ffffffa6] p-[26px]"
      >
        <Image :src="home" class="w-5 h-5" />
        <span class="text-10 mt-0.5">Lobby</span>
      </div>
    </DraggableIcon>
  </div>
</template>

<script setup lang="ts">
import DraggableIcon from "./compontents/DraggableIcon.vue";
import { getGameUrl, getGameStartupDiagram } from "@/api/game";
import home from "./images/home.png";
import gameBg from "./images/gameBg.png";
import useTrack from "@/hooks/useTrack";
import debounce from "lodash-es/debounce";
const route = useRoute();
const router = useRouter();
const searchParams = route.query;
const gameCode = searchParams.gameCode as string;
const language = (searchParams.language as string) || "pt";
const homeParams = localStorage.getItem("homeParams") || "";
const gameUrl = ref("");
const isLoading = ref(true);
let timer: any;
const gameStartupDiagram = ref("");
const getGameUrlData = async () => {
  console.log(gameCode, language, homeParams);
  try {
    const result = await getGameUrl({
      gameCode,
      language,
      device: "Mobile",
    });
    if (result.code === 1) {
      gameUrl.value = result.data.url;
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  getGameUrlData();
  const { code, data } = await getGameStartupDiagram({ language });
  if (code === 1) {
    gameStartupDiagram.value = data?.picture || "";
    if (gameStartupDiagram.value) {
      timer = setTimeout(() => {
        isLoading.value = false;
      }, 3000);
    } else {
      isLoading.value = false;
    }
  }

  const { track2Platform, trackName } = useTrack();
  track2Platform(trackName.StartTrial, { product_catalog_id: gameCode, gameCode });
});

onUnmounted(() => {
  clearTimeout(timer);
});

const handleNavigation = debounce(() => {
  router.back();
}, 300);
</script>

<style scoped>
.gameContainer {
  position: relative;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
}

#gameIframe {
  margin-top: calc(var(--safe-top, 0) + 2px);
  height: calc(var(--vh, 1vh) * 100 - var(--safe-top, 0) - 2px);
}
</style>
